import React from "react";

import { identicon } from "@dicebear/collection";
import { createAvatar } from "@dicebear/core";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";

export const Img = styled.img`
  height: calc(3 * 0.55rem);
  width: calc(3 * 0.55rem);
  margin-right: 0.4rem;
  border: solid 1px ${(props) => props.theme.colors.lightGray};
  border-radius: 100%;
`;

type Props = {
  src?: string;
  seed?: string | null;
};

const createAvatarDataUri = (seed?: string | null) => {
  return createAvatar(identicon, {
    seed: seed ?? uuidv4(),
  }).toDataUriSync();
};

function Avatar({ src, seed }: Props) {
  return <Img src={src || createAvatarDataUri(seed)} loading="lazy" />;
}

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error: Error) {
    // Update state to show fallback UI on next render
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error in CellEntityAvatar:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI in case of an error
      return <Img />;
    }

    return this.props.children;
  }
}

export default function CellEntityAvatar({ src, seed }: Props) {
  return (
    <ErrorBoundary>
      <Avatar src={src} seed={seed} />
    </ErrorBoundary>
  );
}
